import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'
import { markdownSummaryToHtml } from './WipOrationEditor'

/**
 * Visual match for WipAiNarrativeEditor (beta) using fixed palette so legacy WIP works without ks theme.
 */
const Section = styled.section`
  margin-top: 28px;
`

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 0;
  overflow: hidden;
`

const NarrHead = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #e0e0e0;
  gap: 12px;
`

const HeadT = styled.span`
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #333;
`

const Meta = styled.span`
  font-size: 12px;
  color: #757575;
  margin-left: auto;
`

const NarrBody = styled.div`
  padding: 18px 22px;
  font-size: 14px;
  line-height: 1.65;
  color: #212121;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 10px;
    font-weight: 700;
    line-height: 1.3;
    color: #212121;
  }
  h1 {
    font-size: 1.25rem;
  }
  h2,
  h3 {
    font-size: 1.1rem;
  }
  h4,
  h5,
  h6 {
    font-size: 1rem;
  }
  p {
    margin: 0 0 12px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 1.35rem;
  }
  li {
    margin: 0.2em 0;
  }
  strong {
    font-weight: 700;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 14px;
    font-size: 13px;
  }
  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 6px 10px;
    text-align: left;
    vertical-align: top;
  }
  th {
    background: #fafafa;
    font-weight: 700;
  }
  .cited {
    background: linear-gradient(0deg, #ede7f6, #ede7f6);
    padding: 0 3px;
    border-radius: 3px;
    border-bottom: 1px dashed #5c4a7a;
  }
`

const WipInternalNarrativeViewer = ({ narrative, loading }) => {
  const html = markdownSummaryToHtml(narrative || '')
  const hasNarrative = Boolean((narrative || '').trim())

  return (
    <Section id="wip-internal-narrative">
      <Card>
        <NarrHead>
          <HeadT>Internal summary</HeadT>
          <Meta>AI — for internal use only</Meta>
          {loading ? <CircularProgress size={14} /> : null}
        </NarrHead>
        {loading && !hasNarrative ? (
          <NarrBody style={{ color: '#898989', fontStyle: 'italic' }}>
            Generating internal summary…
          </NarrBody>
        ) : hasNarrative ? (
          <NarrBody dangerouslySetInnerHTML={{ __html: html }} />
        ) : (
          <NarrBody style={{ color: '#898989', fontStyle: 'italic' }}>
            Use &quot;Generate with AI&quot; on the client summary above to create an internal
            narrative.
          </NarrBody>
        )}
      </Card>
    </Section>
  )
}

WipInternalNarrativeViewer.propTypes = {
  narrative: PropTypes.string,
  loading: PropTypes.bool,
}

WipInternalNarrativeViewer.defaultProps = {
  narrative: '',
  loading: false,
}

export default WipInternalNarrativeViewer
